import React from 'react';
import { TFunction } from 'i18next';
import { VisitDtoModelType } from '../../../../store/mst/models';
import DurationRow from './DurationRow';
import TimeWindows from '../../../shared/TimeWindows';
import DeliveryDate from './DeliveryDate';
import PackagesSection from './PackagesSection';
import { TagsRow } from '../../../shared/Tags';
import { TimelineViolationTypes } from '../../../../helpers/lateness';
import OrderWarning, { OrderWarningType } from '../../OrderWarning';
import { OrderDetailsCardRow } from './DeliveryDetails';
import { CollapsibleNote } from '../../../shared/DetailsCard';

const orderDetails = (t: TFunction, visit: VisitDtoModelType): OrderDetailsCardRow[] => {
  const instructions = visit.instructions?.trim();
  const notesTwo = visit.notes2;
  const noTimeWindows = !visit.timeWindows?.length;
  const duration = `${visit.durationMinutes} ${t('orderDetails.durationSuffix')}`;
  const load = visit.load === null ? '' : `${visit.load} ${t('orderDetails.loadSuffix')}`;

  const packages = visit.packages?.slice() || [];
  const orderAttempt = visit.attempt();
  const scannedPackages = orderAttempt?.scannedPackages?.slice() || [];

  return [
    {
      label: t('orderDetails.customerOrderNumber'),
      value: visit.customerOrderNumber ? visit.customerOrderNumber : undefined,
    },
    {
      label: t('orderDetails.tags'),
      value: visit.tagNames?.length ? (
        <TagsRow
          tags={visit.tagNames}
          prefix={
            visit.timeline?.violations?.some((v) => v.type === TimelineViolationTypes.TAG_MISMATCH)
              ? <OrderWarning types={[OrderWarningType.TAG_MISMATCH]} />
              : undefined
          }
        />
      ) : undefined,
    },
    {
      label: t('orderDetails.deliveryDate'),
      value: visit.deliveryDate ? <DeliveryDate deliveryDate={visit.deliveryDate} isDateMismatched={visit.isDateMismatched ?? false} /> : undefined,
    },
    {
      label: t('orderDetails.deliverBetween.title'),
      value: noTimeWindows ? undefined : <TimeWindows visit={visit} showLateness={true} />,
    },
    {
      label: t('orderDetails.duration'),
      value: duration ? <DurationRow value={duration} /> : undefined,
    },
    {
      label: t('orderDetails.load'),
      value: load || undefined,
    },
    {
      label: t('orderDetails.packages'),
      value: packages.length > 0 ? <PackagesSection packages={packages} scannedPackages={scannedPackages} /> : undefined,
    },
    {
      label: t('orderDetails.instructions'),
      value: instructions ? <CollapsibleNote value={instructions} /> : undefined,
    },
    {
      label: t('orderDetails.noteTwo'),
      value: notesTwo ? <CollapsibleNote value={notesTwo} /> : undefined,
    },
    ...(visit.customFieldsList || [])
      .filter((field) => !!field.value?.trim())
      .map((field) => ({
        label: field.key,
        value: <CollapsibleNote value={field.value} />,
      })),
    {
      label: t('orderDetails.routificOrderNumber'),
      value: visit.routificOrderNumber,
    },
  ];
};

export default orderDetails;
